import axios from "axios"

axios.defaults.xsrfCookieName = 'crmcsrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';

const AUTH = '/auth';
const IA = '/ia/api';
const VAC = '/vacation';
const GITLAB = '/gitlab/api';

export let backend = {
    getEmployees: function () {
        return axios.get(`${AUTH}/employees/`);
    },
    getAreas: function () {
        return axios.get(`${IA}/areas`);
    },
    getCompanies: function () {
        return axios.get(`${AUTH}/companies`);
    },
    getProjects: function () {
        return axios.get(`${IA}/projects`);
    },
    login: function (username, password) {
        const data = new FormData();
        data.append('username', username);
        data.append('password', password);
        return axios.post(`${AUTH}/login/`, data);
    },
    logout: function () {
        return axios.get(`${AUTH}/logout/`);
    },
    checkStatus: function () {
        return axios.get(`${AUTH}/login-check/`);
    },
    getColors: function () {
        return axios.get(`${IA}/colors/`);
    },
    getProfile: function (params) {
        return axios.get(`${AUTH}/employees/get_profile/`, {params: params});
    },
    saveProfile: function (params) {
        return axios.patch(`${AUTH}/employees/save_profile/`, params);
    },
    getPlaces: function (archived = false) {
        return axios.get(`${IA}/places/`, {params: {'archived': archived}});
    },
    getWorktimePlan: function (params) {
        return axios.get(`${IA}/plans/`, {params: params});
    },
    createWorktimePlan: function (data) {
        return axios.post(`${IA}/plans/`, data);
    },
    updateWorktimePlan: function (id, data) {
        return axios.patch(`${IA}/plans/${id}/`, data);
    },
    deleteWorktimePlan: function (id) {
        return axios.delete(`${IA}/plans/${id}/`)
    },
    getReports: function (params) {
        return axios.get(`${IA}/reports/`, {params: params});
    },
    createReport: function (data) {
        return axios.post(`${IA}/reports/`, data);
    },
    updateReport: function (id, data) {
        return axios.patch(`${IA}/reports/${id}/`, data);
    },
    deleteReport: function (reportId) {
        return axios.delete(`${IA}/reports/` + reportId + "/");
    },
    getAbsences: function (params) {
        /*
            params - object containing optional parameters for api lookup:
            'user' - id of User in internal-app MySQL database
            'from_date' - day formatted "YYYY-MM-DD"
            'to_date' - day formatted "YYYY-MM-DD"
            'limit' - limit
        */
        return axios.get(`${IA}/absences/`, {params: params});
    },
    makeAbsences: function (params) {
        return axios.post(`${IA}/absences/create_multiple/`, params);
    },
    removeAbsences: function (params) {
        return axios.post(`${IA}/absences/destroy_multiple/`, params);
    },
    getSummaries: function (params) {
        /*
        params - object containing optional parameters for api lookup:
            'year' - integer
            'month' - as integer in range [1, 12]
         */
        return axios.get(`${IA}/summary/`, {params: params});
    },
    getEmployeeDetailsWorktime: function (user_id) {
        return axios.get(`${IA}/summary/employee_details_worktime/${user_id}/`);
    },
    getUsername: function (params) {
        return axios.get(`${AUTH}/employees/get_username/`, {params: params});
    },
    reportWork: function (params) {
        return axios.post(`${IA}/report_work/`, params);
    },
    getRemoteUsers: function (params) {
        return axios.get(`${IA}/remote_users/`, {params: params});
    },
    getActiveUsersByArea: function () {
        return axios.get(`${IA}/areas_users/`);
    },
    getStructure: function () {
        return axios.get(`${IA}/structure`);
    },
    makeVacation: function (params) {
        return axios.post(`${VAC}/create_vacation/`, params);
    },
    removeVacation: function (params) {
        return axios.post(`${VAC}/remove_vacation/`, params);
    },
    getMyVacation: function (params) {
        return axios.get(`${VAC}/get_my_vacation_requests/`, params);
    },
    getNewVacation: function (params) {
        return axios.get(`${VAC}/get_my_employees_vacation_requests/`, params);
    },
    acceptVacation: function (params) {
        return axios.post(`${VAC}/accept_vacation/`, params);
    },
    discardVacation: function (params) {
        return axios.post(`${VAC}/discard_vacation/`, params);
    },
    getGitlabUserSummary: function (username) {
        return axios.get(`${GITLAB}/user_summary/${username}/`);
    }
};



// WEBPACK FOOTER //
// ./app/backend.js